export const normalizeInvoiceStatus = (status) => {
  const value = String(status || "").trim().toUpperCase();
  if (["PAID", "SUCCESS", "COMPLETED"].includes(value)) return "PAID";
  return ["", "ONGOING", "UPCOMING", "CREATED", "SCHEDULED"].includes(value)
    ? "PENDING" : value;
};

const positive = (value) => Number.isFinite(Number(value)) && Number(value) > 0
  ? Number(value) : 0;
const sessions = (cycle) => positive(cycle?.totalNoOfClasses || cycle?.classes || cycle?.sessionCount);

const explicitStart = (invoice, cycles) => {
  for (const key of ["sourceCycleNumber", "cycleNumber"]) {
    const number = positive(invoice[key]);
    if (Number.isInteger(number) && number > 0) return number - 1;
  }
  const index = invoice.sourceCycleIndex;
  if (index !== null && index !== undefined && index !== "" && Number.isInteger(Number(index)) && Number(index) >= 0) {
    return Number(index);
  }
  const name = String(invoice.cycleName || "").trim().toLowerCase();
  const match = name ? cycles.findIndex(c => String(c.name || "").trim().toLowerCase() === name) : -1;
  return match >= 0 ? match : null;
};

// An invoice purchases a block of cycles, not necessarily a single cycle.
// Legacy blocks have no sourceCycleNumber, so place them chronologically.
export const mapInvoicesToCycles = (cycles = [], invoices = []) => {
  const mapped = cycles.map(() => null);
  const ordered = [...invoices].filter(i => normalizeInvoiceStatus(i.status) !== "VOID")
    .sort((a, b) => (new Date(a.createdAt || 0) - new Date(b.createdAt || 0)) || String(a._id || "").localeCompare(String(b._id || "")));
  let nextLegacyStart = 0;
  for (const invoice of ordered) {
    const explicit = explicitStart(invoice, cycles);
    const start = explicit ?? (invoice.invoiceType === "ACTIVATION" ? 0 : nextLegacyStart);
    let count = positive(invoice.totalCycles);
    if (!Number.isInteger(count)) count = 0;
    if (!count) {
      const targetClasses = positive(invoice.totalClasses);
      const targetAmount = positive(invoice.totalAmount);
      let covered = 0;
      for (let idx = start; idx < cycles.length; idx += 1) {
        const quantity = targetClasses ? sessions(cycles[idx]) : positive(cycles[idx]?.monthlyFee || cycles[idx]?.paymentAmount);
        if (!quantity) break;
        covered += quantity;
        if (Math.abs(covered - (targetClasses || targetAmount)) < 0.01) { count = idx - start + 1; break; }
        if (covered > (targetClasses || targetAmount)) break;
      }
    }
    count = count || 1;
    const end = start + count;
    // An explicit future pending invoice must not shift older legacy blocks.
    if (explicit === null || normalizeInvoiceStatus(invoice.status) === "PAID") {
      nextLegacyStart = Math.max(nextLegacyStart, end);
    }
    const block = cycles.slice(start, end);
    const blockClasses = block.reduce((sum, c) => sum + sessions(c), 0);
    for (let idx = start; idx < Math.min(end, cycles.length); idx += 1) {
      if (normalizeInvoiceStatus(mapped[idx]?.invoice?.status) === "PAID") continue;
      mapped[idx] = {
        invoice,
        amount: positive(invoice.totalAmount) * (blockClasses > 0 && block.length === count
          ? sessions(cycles[idx]) / blockClasses : 1 / count),
      };
    }
  }
  return mapped;
};

export const getCyclePaymentStatus = (cycle, mapping, fallbackStatus) => normalizeInvoiceStatus(
  mapping?.invoice?.status || cycle?.paymentStatus || cycle?.financeStatus ||
  cycle?.feeStatus || cycle?.invoiceStatus || fallbackStatus
);
